import Cookies from 'js-cookie';
import toast from "react-hot-toast";
import { axiosInstance } from '../lib/axios';
//api
const loginapi = async (email, password) => {
    try {

        const res = await axiosInstance.post(
            `/users/login`,
            { email, password }
        );

        // toast.success("Successfully Login");
        return res.data.data

    } catch (err) {
        console.log(err.response?.data?.message);
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
};

const checkAuthapi = async () => {
    try {
        const token = Cookies.get("accessToken");
        const res = await axiosInstance.get(
            `/users/profile`,
            {
                headers: { Authorization: `Bearer ${token}` },
            }
        );
        return res.data.data

    } catch (err) {
        console.log(err.response?.data?.message);
        // toast.error(err.response?.data?.message || "Something went wrong!");
    }
};

const registeruser = async (form) => {
    try {
        const {
            fullname, username, password, confirmPassword, email
        } = form;

        if (password !== confirmPassword) {
            toast.error("password and confirm password are not same");
            console.log(password, confirmPassword)
            return
        }
        const formData = new FormData();

        formData.append("fullName", fullname);
        formData.append("username", username);
        formData.append("password", password);
        formData.append("email", email);

        const res = await axiosInstance.post(
            `/users/register`,
            formData,
            {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
        );

        // console.log("category", res)
        toast.success("Successfully Registered!");
        return res.data?.data;

    } catch (err) {
        console.error(err);
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
};

const updateuser = async (form) => {
    try {
        const {
            profileImage, address, fullName
        } = form;

        const formData = new FormData();

        formData.append("fullName", fullName);
        formData.append("address", JSON.stringify(address));
        formData.append("avatar", profileImage)

        const accessToken = Cookies.get("accessToken");

        const res = await axiosInstance.post(
            `/users/update`,
            formData,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "multipart/form-data",
                },
            }
        );

        // console.log("category", res)
        toast.success("Successfully Registered!");
        return res.data?.data;

    } catch (err) {
        console.error(err);
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
};

const resetpassword = async (form) => {
    try {

        const { oldPassword, newPassword } = form
        const accessToken = Cookies.get("accessToken");

        const res = await axiosInstance.post(
            `/users/resetpassword`,
            {
                oldPassword, newPassword
            }
            ,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "application/json",
                },
            }
        );

        // console.log("category", res)
        toast.success("Successfully Registered!");
        return res.data?.data;

    } catch (err) {
        console.error(err);
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
};
export {
    loginapi,
    checkAuthapi,
    registeruser,
    updateuser,
    resetpassword
}
